const labels: Record<string, string> = {
  'edit text': 'Editar texto',
  'draft from text': 'Criar a partir do texto',
  'review image': 'Analisar imagem',
  'review code': 'Analisar código',
  'review text': 'Revisar texto',
  'generate from text': 'Gerar a partir do texto',
  'touch up image': 'Ajustar imagem',
  'Translate to': 'Traduzir para',
  Translate: 'Traduzir',
  'Change tone to': 'Mudar o tom para',
  'Change tone': 'Mudar o tom',
  'Improve writing': 'Melhorar a escrita',
  'Improve writing for it': 'Melhorar a escrita',
  'Make it longer': 'Expandir texto',
  'Make it shorter': 'Encurtar texto',
  'Continue writing': 'Continuar escrevendo',
  'Write an article about this': 'Escrever um artigo sobre isso',
  'Write a tweet about this': 'Escrever uma publicação curta',
  'Write a poem about this': 'Escrever um poema sobre isso',
  'Write a blog post about this': 'Escrever uma publicação para blog',
  'Brainstorm ideas about this': 'Explorar ideias sobre isso',
  'Explain this image': 'Explicar esta imagem',
  'Explain this code': 'Explicar este código',
  'Check code error': 'Verificar erros no código',
  'Fix spelling': 'Corrigir ortografia',
  'Fix spelling for it': 'Corrigir ortografia',
  'Fix grammar': 'Corrigir gramática',
  'Improve grammar for it': 'Corrigir gramática',
  'Explain selection': 'Explicar seleção',
  'Explain this': 'Explicar conteúdo',
  Summarize: 'Resumir',
  Summary: 'Resumo',
  'Generate headings': 'Gerar títulos',
  'Create headings': 'Criar títulos',
  'Generate outline': 'Gerar estrutura',
  'Write outline': 'Escrever estrutura',
  'Generate an image': 'Gerar uma imagem',
  'Brainstorm ideas with mind map': 'Explorar ideias com mapa mental',
  'Brainstorm mindmap': 'Criar mapa mental',
  'Expand mind map': 'Expandir mapa mental',
  'Expand from this mind map node': 'Expandir a partir deste nó do mapa',
  'Regenerate mind map': 'Gerar mapa mental novamente',
  'Generate presentation': 'Gerar apresentação',
  'Create a presentation': 'Criar apresentação',
  'Make it real': 'Transformar em protótipo',
  'Find actions': 'Identificar ações',
  'Find action items from it': 'Identificar ações',
  'Continue in AI Chat': 'Continuar na conversa com IA',
  'Continue in chat': 'Continuar na conversa',
  'Image processing': 'Processar imagem',
  'AI image filter': 'Filtro de imagem com IA',
  'AI image filter clay style': 'Filtro de argila',
  'AI image filter sketch style': 'Filtro de esboço',
  'AI image filter anime style': 'Filtro de anime',
  'AI image filter pixel style': 'Filtro de pixels',
  'Generate a caption': 'Gerar legenda',
  'Insert below': 'Inserir abaixo',
  'Insert above': 'Inserir acima',
  'Use as caption': 'Usar como legenda',
  'Create new note': 'Criar nota',
  'Replace selection': 'Substituir seleção',
  'Ask AI': 'Perguntar à IA',
  Retry: 'Tentar novamente',
  'Action with above': 'Ação no conteúdo acima',
  English: 'Inglês',
  'Brazilian Portuguese': 'Português do Brasil',
  Spanish: 'Espanhol',
  German: 'Alemão',
  French: 'Francês',
  Italian: 'Italiano',
  'Simplified Chinese': 'Chinês simplificado',
  'Traditional Chinese': 'Chinês tradicional',
  Japanese: 'Japonês',
  Russian: 'Russo',
  Korean: 'Coreano',
  Professional: 'Profissional',
  Informal: 'Informal',
  Friendly: 'Amigável',
  Critical: 'Crítico',
  Humorous: 'Bem-humorado',
  'Clay style': 'Estilo de argila',
  'Sketch style': 'Estilo de esboço',
  'Anime style': 'Estilo de anime',
  'Pixel style': 'Estilo de pixels',
  Clearer: 'Mais nítida',
  'Remove background': 'Remover fundo',
  'Convert to sticker': 'Converter em adesivo',
  image: 'Imagem',
};

/** Localize presentation labels without changing the AI protocol values. */
export function localizeAILabel(value: string): string {
  return labels[value] ?? value;
}
